import { CampaignPage } from './CampaignPage'
import { withCampaignPage } from './withCampaignPage'

const ConnectedCampaignPage = withCampaignPage(CampaignPage)

export { ConnectedCampaignPage as CampaignPage }
